import { Outlet } from "react-router-dom";
import LeftBar from "../components/LeftBar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import useGlobal from "../hooks/useGlobal";

import medalsImage from "../assets/Medals.png";
import madFundImage from "../assets/MAD Fund.png";

const MainLayout = () => {
  const { sidebarCollapsed } = useGlobal();

  const resetQuote = async () => {
    await localStorage.removeItem("quote");
    await localStorage.removeItem("progress");
    await localStorage.removeItem("deletedSchools");
    await localStorage.removeItem("steps");
    window.location.reload();
  };

  return (
    <div className="relative flex min-h-screen bg-[#F5F5F5] w-full mx-auto overflow-x-hidden">
      <div className="hidden lg:block">
        <LeftBar />
      </div>
      <main
        className={`h-full w-full ${
          sidebarCollapsed ? "lg:pl-24" : "lg:pl-[20%]"
        } transition-all duration-200`}
      >
        <Header />
        <div className="pb-4 px-2 md:px-6">
          <Outlet />

        </div>

                <p
          onClick={resetQuote}
          className="inline-flex lg:hidden relative ml-4 text-sm font-normal text-white bg-primary px-8 py-2 rounded hover:bg-primary-hover cursor-pointer mb-2"
        >
          Reset Quote
        </p>
            <section className="w-full bg-font-primary  px-4 sm:px-6 py-5 sm:py-6 mt-8">
            <h3 className="text-center font-bold text-base sm:text-base md:text-xl text-white mb-2">
              Submit your quote before April 1st to be entered into the Make A
              Difference Fund
            </h3>
            <img
              src={medalsImage}
              alt="Make A Difference Fund prizes"
              className="w-full h-auto"
            />

            <div className="flex justify-center my-4">
              <a
                href="http://schooladvice.co.uk/Make-A-Difference-Fund"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center px-6 py-2 rounded-lg bg-white text-primary font-semibold hover:bg-slate-100 transition-colors"
              >
                Learn more
              </a>
            </div>

            <img
              src={madFundImage}
              alt="Make A Difference Fund"
              className="mx-auto w-full max-w-[420px] h-auto"
            />
          </section>

        <Footer />
      </main>
    </div>
  );
};

export default MainLayout;
